export class DeterminationModel {
    constructor(
      public determinationId: number,
      public determinationName: string) {}
  }
